import FeaturedAuthor from "./featured-author.component";

export default FeaturedAuthor;
